import { DASH } from 'modules/constants'
import { FC } from 'react'
import styled from 'styled-components'
import { DateFormatted } from '../DateFormatted'
import { DatePeriod, containsFilledDatePeriod } from './types'

type Wrap = {
  wrap?: boolean
}

type Props = {
  period?: DatePeriod
  className?: string
  showEmpty?: boolean
} & Wrap

const DatePeriodContainer = styled.span<Transient<Wrap>>`
  display: flex;
  gap: 0 2px;
  ${({ $wrap }) => $wrap && 'flex-wrap: wrap'}
`

const DatePeriodFormatted: FC<Props> = ({ className = '', period, showEmpty, wrap = false }) => {
  if (!containsFilledDatePeriod(period)) {
    return showEmpty ? DASH : null
  }

  return (
    <DatePeriodContainer className={className} $wrap={wrap}>
      <span>{<DateFormatted date={period.start_date} />}</span>
      <span> &ndash; </span>
      <span>{<DateFormatted date={period.end_date} />}</span>
    </DatePeriodContainer>
  )
}

export default DatePeriodFormatted
